<template>
	<div>
		<div class="view-framework">
			<userLeft></userLeft>
			<div class="view-framework-body">
				<div class="view-framework-main">
					<div class="box">
						<h2 class="box-caption">
							订单详情
							<span class="h4 pl10 text-muted">
								（单号：{{orderList.order_no}}
								<span class="sep">|</span>
								{{orderList.create_time}}）
							</span>
						</h2>
						<div class="box sellrecords-steps">
							<el-steps :active="active" finish-status="success" align-center>
							  <el-step title="卖卡提交" :description="orderList.create_time" ></el-step>
							  <el-step title="受理成功" :description="orderList.create_time"></el-step>
							  <el-step title="验证卡券" :description="orderList.create_time"></el-step>
								<el-step :title="orderList.delivery_status===30?'交易成功':'交易失败'" :description="orderList.delivery_status===20?orderList.result_date:orderList.accomplish_date" :status='orderList.delivery_status === 40 || orderList.delivery_status === 60?"error ":orderList.delivery_status === 30?"success":"wait "'></el-step>
							</el-steps>
						</div>
						<div class="alert alert-info">
							此次交易共1张卡，交易成功：
							<span class="text-red fsz16">{{orderList.delivery_status === 30?1:0}}</span>
							 张，失败
							 <span class="text-red fsz16">{{orderList.delivery_status != 30 && orderList.delivery_status !=20?1:0}}</span>
							 张，您共获得：
							 <span class="text-red fsz16">￥{{orderList.real_price}}</span>
							  元，款项已经打入您的账户余额中，你可以查看
								<router-link :to="{path:'/user'}">账户余额</router-link>
						</div>
						<div class="table-responsive">
							  <el-table
							    :data="orderLists"
							    stripe
									border
							    style="width: 100%">
									<el-table-column
									  prop="goods_name"
									  label="卡种"
										width='200'>
									</el-table-column>
									<el-table-column label="卡号" width='180'>
										<template slot-scope="scope">
											<span  >{{scope.row.card?scope.row.card:'无卡号'}}</span>
										</template>
									</el-table-column>
									<el-table-column label="卡密" width='180'>
										<template slot-scope="scope">
											<span  >{{scope.row.card_pass?scope.row.card_pass:'无卡密'}}</span>
										</template>
									</el-table-column>
									<el-table-column label="文本" width='180' prop='content' v-if="orderList.form_num === 5"></el-table-column>
									<el-table-column label="图片/二维码" width='180' v-if="orderList.form_num === 4 ||orderList.form_num === 6 ">
										<template slot-scope="scope">
											<img :src="scope.row.order_image.file_path" style="width: 100px;height: 100px;"/>
										</template>
									</el-table-column>
									<el-table-column
									  prop="order_price"
									  label="面值"
										width='90'>
									</el-table-column>
									<el-table-column
									  prop="recycle_price"
									  label="回收价"
										width='90'>
									</el-table-column>
<!-- 									<el-table-column label="实际价" width='90'>
										<template slot-scope="scope">
											<span  class="text-orange">{{scope.row.real_price}}</span>
										</template>
									</el-table-column> -->
									<el-table-column label="状态" >
										<template slot-scope="scope">
											<span  class="" :class="{'text-success':scope.row.delivery_status===30,
											'text-red':scope.row.delivery_status===40 || scope.row.delivery_status === 60,
											'text-gray':scope.row.delivery_status===10 || scope.row.delivery_status === 50,
											'text-blue':scope.row.delivery_status === 20
											}">{{delivery_status[scope.row.delivery_status]}}</span>
										</template>
									</el-table-column>
									<el-table-column label="说明" width='250'>
										<template slot-scope="scope">
											<span  class="text-red">{{scope.row.result_message}}</span>
										</template>
									</el-table-column>
							  </el-table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				orderId:"",
				orderList:[],
				orderLists:[],
				active: 0,
				delivery_status:{
					10:'处理中',
					20:'待结算',
					30:'成功',
					40:'失败',
					50:'待处理',
					60:'异常订单'
				},
			}
		},
		created() {
			var query = this.$route.query;
			this.orderId = query.orderId
			this.getOrderDetail()
		},
		methods:{

			getOrderDetail(){
				let token = localStorage.getItem('token')
				this.$api.orderList({
					token: token,
					type:1,
					page:1,
					name:this.orderId
				}).then(res => {
					if(res.code === 1){
						this.orderList = res.data.data[0]
						this.orderLists = res.data.data
						switch (this.orderList.delivery_status){
							case 10:
							this.active = 1
							break
							case 20:
							this.active = 3
							break
							case 30:
							this.active = 3
							break
							case 40:
							this.active = 3
							break
							case 50:
							this.active = 1
							break
							case 60:
							this.active = 3
							break

						}
					}else{

					}

				})
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/user/orderDetail.vue